var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 30,
    viewBox: "0 0 24.001 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4310",
    d: "M20.922-8.661a6.332 6.332 0 0 1 2.639-5.128.658.658 0 0 0 .257-.457.651.651 0 0 0-.162-.5A7.1 7.1 0 0 0 18.772-17c-2.3-.212-4.489 1.325-5.659 1.325S10.039-17 8.134-17A7.291 7.291 0 0 0 2-13.338C-.613-8.913 1.332-2.42 3.808 1.21c1.238 1.749 2.721 3.723 4.68 3.657s2.585-1.179 4.856-1.179 2.911 1.179 4.9 1.139S21.6 3.038 22.853 1.29a16.053 16.053 0 0 0 1.864-3.538.655.655 0 0 0-.313-.808 6.288 6.288 0 0 1-3.482-5.605Z",
    transform: "translate(-.757 17.015)",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4312",
    d: "M13.906-18.88a6.619 6.619 0 0 0 1.541-3.9.632.632 0 0 0-.222-.507.632.632 0 0 0-.536-.137 6.758 6.758 0 0 0-3.55 2.11 6.4 6.4 0 0 0-1.579 3.79.632.632 0 0 0 .2.479.632.632 0 0 0 .493.165 5.659 5.659 0 0 0 3.653-2Z",
    transform: "translate(-9.56 23.44)",
    fill: "#4b5474"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5246"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4519",
    transform: "translate(0 8.116)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4309",
    d: "M-6.802-6.625h37.6v35.133h-37.6Z",
    fill: "#4b5474"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4520",
    transform: "translate(12.282)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4311",
    d: "M-6.316-6.316h18.52v19.192h-18.52Z",
    fill: "#4b5474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSvg);
export default __webpack_public_path__ + "static/media/appleSvg.93d6437674d97c1e50fe3a8ccfb8b81c.svg";
export { ForwardRef as ReactComponent };